define(['edge/platform/base/BaseCtrl',
        'text!./templates/quote-policy-box.html',
    'text!customerEdge/quoteandbind/common/views/discounts.html'],
    (BaseCtrl,templateStr,DiscountsTemplate)=> {
        return ['$filter','ViewDiscountsService','ModalService',($filter, ViewDiscountsService, ModalService )=> {
            let labelIDCounter = 0; //counter to allow for unique labels to be created for radio buttons

            return {
                restrict: 'A',
                scope: {
                    buy: '=',
                    quote: '=gwQnbQuotePolicyBox',
                    loading: '=',
                    nextSteps: '='
                },
                template: templateStr,
                controller: ['$scope','$modal', (scope,$modal)=> {

                    scope.labelIDCounter = labelIDCounter++;
                    scope.paymentPeriod = 'fullTerm';

                    scope.buyLabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.Buy this policy');
                    scope.buyInFullLabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.X Months', {termMonths: scope.quote.termMonths});
                    scope.buyInFullPALabel = $filter('translate')('quoteandbind.directives.QuotePolicyBox.Pay in Full');

                    scope.buyQuote = ()=> {
                        const termInMonths = (scope.paymentPeriod === 'fullTerm') ? scope.quote.termMonths : 1;
                        scope.buy(scope.quote, termInMonths);
                    };

                    scope.goToNextSteps = ()=>{
                         const termInMonths = (scope.paymentPeriod === 'fullTerm') ? scope.quote.termMonths : 1;
                         scope.nextSteps(scope.quote, termInMonths);
                    };

                    scope.viewDiscounts = (quote)=>{
                        scope.discounts = quote.discounts;
                        var modalInstance = $modal.open({
                            template: DiscountsTemplate,
                            scope: scope
                        });
                    };
/*
        CHG0031272 -    Display alert popup message when
                        comprehensive or collision coverages are not selected
                        for any vehicle on the quote
        AB - 06/27/2018
*/
                    scope.confirmBuy = (quote) => {
                        veh = quote.lobs.personalAuto.vehicleCoverages; //get all vehicles on the quote
                        var NoCompColl = 0
                        for(i in veh){ // loop thru each vehicle on the quote
                            var covs = veh[i].coverages // get all coverages for a vehicle
                            for(c in covs){
                                if(covs[c].name === "Comprehensive" && covs[c].selected === false){
                                    NoCompColl = NoCompColl + 1
                                };

                                if(covs[c].name === "Collision" && covs[c].selected === false){
                                    NoCompColl = NoCompColl + 1
                                };
                            }
                        }

                       if (NoCompColl > 0){
                            var title = $filter('translate')('quoteandbind.directives.QuotePolicyBox.CoverageAlert.heading')
                            var message = $filter('translate')('quoteandbind.directives.QuotePolicyBox.CoverageAlert.static')
                            var continueModel = ModalService.showCoverageAlert(title, message);
                            continueModel.result.then(function(){scope.buyQuote()}, function(){})
                           }
                        else {
                            scope.buyQuote()
                        }
                    };

/* end of CHG0031272 */

                    //TODO: viewdiscounts to be enabled after clarification on how discounts are applied
                    /*  PersonalAuto={
                        discountsLob : "PA"
                        };

                    HomeOwners={
                        discountsLob : "HO"
                    }

                    scope.viewDiscounts = (quote)=>{
                        console.log("view discounts is clicked");
                        if(quote.lobs.personalAuto){
                            ViewDiscountsService.getDiscounts(PersonalAuto);
                        }else if (quote.lobs.homeowners){
                            ViewDiscountsService.getDiscounts(HomeOwners);
                        }

                    };*/

                }]
            };
        }];
    });



/** WEBPACK FOOTER **
 ** ./common/js/src/edge/quoteandbind/common/directives/QuotePolicyBox.js
 **/